import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-type-entretient-detail',
  templateUrl: './type-entretient-detail.component.html',
  styleUrls: ['./type-entretient-detail.component.scss']
})
export class TypeEntretientDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
